import { render, staticRenderFns } from "./TeamMetricsBtns.vue?vue&type=template&id=53600d54"
import script from "./TeamMetricsBtns.vue?vue&type=script&lang=ts"
export * from "./TeamMetricsBtns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports